import { Injectable  } from '@angular/core';

@Injectable ()
export class DriversService {
  newEdit: number;

  setNewEdit(value) {
    this.newEdit = value;
  }
  getNewEdit() {
    return this.newEdit;
  }

}
